import {
  Avatar,
  Flexbox,
  Form,
  ListManager,
  PageHeader,
  Paginator,
  QuickFilter,
  Styles,
} from '@/components'
import useAxiosRequest from '@/hooks/useAxiosRequest'
import usePageTitle from '@/hooks/usePageTitle'
import useQuery from '@/hooks/useQuery'
import dateMask from '@/lib/masks/date'
import reports from '@/services/api/reports'
import React from 'react'
import { Link } from 'react-router-dom'
import FilterAdoptions from '../../components/FilterAdoptions'
import FairFilter from './FairFilter'

function AdoptionsList({ title }) {
  usePageTitle({ title })

  const query = useQuery()
  const { data, loading, error } = useAxiosRequest(
    reports.adoptionsList,
    query,
  )

  return (
    <Styles.Container className="grid-xl">
      <PageHeader
        title="Lista de adoções"
        subtitle="Adoções confirmadas em feiras, online, diretas e manuais"
        icon="far fa-heart"
        rightAction={() => <FilterAdoptions donors={data?.donors} />}
      />
      <QuickFilter
        initialValues={{
          source: '',
          'fair.id_eq': '',
        }}
        title="Filtrar"
        renderForm={() => (
          <>
            <Flexbox.Column className="col-3 mt-2">
              <Form.Group>
                <Form.Label className="label-sm pt-2" htmlFor="source">
                  Tipo
                </Form.Label>
                <Form.ValidationField name="source">
                  {({ field }) => (
                    <Form.Select
                      // eslint-disable-next-line react/jsx-props-no-spreading
                      {...field}
                      id="source"
                      className="select-sm"
                      placeholder="Selecione o tipo"
                    >
                      <option value="">Todas</option>
                      <option value="fair">Apenas adoções em feiras</option>
                      <option value="direct">Apenas adoções diretas</option>
                      <option value="online_fair">Apenas adoções na Feira Online</option>
                      <option value="manual">Apenas adoções manuais</option>
                    </Form.Select>
                  )}
                </Form.ValidationField>
              </Form.Group>
            </Flexbox.Column>
            <Flexbox.Column className="col-4 mt-2">
              <Form.Group>
                <Form.Label className="label-sm pt-2" htmlFor="fairTitle">
                  Feira
                </Form.Label>
                <Form.ValidationField name="['fair.id_eq']">
                  {({ field, form }) => (
                    <FairFilter
                      selectedFair={data?.selectedFair}
                      onChange={(fairId) => form.setFieldValue(field.name, fairId)}
                    />
                  )}
                </Form.ValidationField>
              </Form.Group>
            </Flexbox.Column>
          </>
        )}
      />
      <ListManager count={data?.count || 0} loading={loading} error={error}>
        {data && (
          <>
            <table className="table table-hover text-small">
              <thead>
                <tr>
                  <th>Pet</th>
                  <th>Doador</th>
                  <th width="220px">Adotante</th>
                  <th width="210px">Data da adoção</th>
                  <th width="240px" className="text-right">
                    Feira
                  </th>
                </tr>
              </thead>
              <tbody>
                {data.rows.map((item) => (
                  <tr key={`${item?.source}-${item?.adoptionId}`}>
                    <td>
                      {item?.animalId ? (
                        <Link
                          to={`/app/pets/${item?.animalId}`}
                          className="text-dark"
                        >
                          <Avatar
                            avatarSize="sm"
                            className="mr-1"
                            name={item?.animalName}
                            photoURL={item?.animalPhotoURL}
                            alt="Imagem do pet"
                          />
                          {item?.animalName}
                        </Link>
                      ) : (
                        <>
                          <Avatar
                            avatarSize="sm"
                            className="mr-1"
                            name={item?.animalName}
                            photoURL={item?.animalPhotoURL}
                            alt="Imagem do pet"
                          />
                          {item?.animalName || '-'}
                        </>
                      )}
                    </td>
                    <td>
                      <span className="text-dark">
                        <Avatar
                          avatarSize="sm"
                          className="mr-1"
                          name={item?.donorFullName}
                          photoURL={item?.donorPhotoURL}
                          alt="Imagem do doador"
                        />
                        {item?.donorFullName || '-'}
                      </span>
                    </td>
                    <td width="220px" className="text-ellipsis">
                      {item?.newTutorId ? (
                        <Link
                          to={`/app/petis-users/${item?.newTutorId}`}
                          className="text-dark"
                        >
                          <Avatar
                            avatarSize="sm"
                            className="mr-1"
                            name={item?.newTutorFullName}
                            photoURL={item?.newTutorPhotoURL}
                            alt="Imagem do adotante"
                          />
                          {item?.newTutorFullName}
                        </Link>
                      ) : (
                        <>
                          <Avatar
                            avatarSize="sm"
                            className="mr-1"
                            name={item?.newTutorFullName}
                            alt={item?.newTutorFullName}
                          />
                          {item?.newTutorFullName || '-'}
                        </>
                      )}
                    </td>
                    <td>{dateMask(item.adoptedAt)}</td>
                    <td className="text-right text-primary">
                      {item?.fairId && !item?.fairIsOnline ? (
                        <Link to={`/app/adoption-fairs/${item?.fairId}/pets`}>
                          {item?.fairTitle}
                        </Link>
                      ) : (
                        item?.fairTitle || '-'
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div className="my-2">
              <Paginator paginatedList={data} />
            </div>
          </>
        )}
      </ListManager>
    </Styles.Container>
  )
}

export default AdoptionsList
